<section class="demo-section">
    <div class="w-100">
        <h4>Users</h4>
        <div class="row">

            <div class="col-md-6">
                <form novalidate [formGroup]="userForm" (submit)="addUsers()">
                    <div class="mb-3">
                        <label for="exampleFormControlInput1" class="form-label"> {{"First Name" | translate}}</label>
                        <input type="text" class="form-control" formControlName="firstName"
                            id="exampleFormControlInput1">
                        <div *ngIf="userForm.get('firstName').invalid && (userForm.get('firstName').dirty || userForm.get('firstName').touched)" class="invalid-feedback">
                            <div *ngIf="userForm.get('firstName').errors.required">
                                Lastname is required
                            </div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="exampleFormControlTextarea1" class="form-label">{{"Last Name" | translate}}</label>
                        <input type="text" class="form-control" formControlName="lastName"
                            id="exampleFormControlInput1">
                        <div *ngIf="userForm.get('lastName').invalid && (userForm.get('lastName').dirty || userForm.get('lastName').touched)"
                            class="invalid-feedback">
                            <div *ngIf="userForm.get('lastName').errors.required">
                                Lastname is required
                            </div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="exampleFormControlTextarea1" class="form-label">{{"Email" | translate}}</label>
                        <input type="email" class="form-control" formControlName="email" id="exampleFormControlInput1">
                        <div *ngIf="userForm.get('email').invalid && (userForm.get('email').dirty || userForm.get('email').touched)"
                            class="invalid-feedback">
                            <div *ngIf="userForm.get('email').errors.required">
                                Email is required
                            </div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="exampleFormControlTextarea1" class="form-label">{{"Username" | translate}}</label>
                        <input type="text" class="form-control" formControlName="userName"
                            id="exampleFormControlInput1">
                        <div *ngIf="userForm.get('userName').invalid && (userForm.get('userName').dirty || userForm.get('userName').touched)"
                            class="invalid-feedback">
                            <div *ngIf="userForm.get('userName').errors.required">
                                Username is required
                            </div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="exampleFormControlTextarea1" class="form-label">{{"Password"| translate}}</label>
                        <input type="password" class="form-control" formControlName="password">
                        <div *ngIf="userForm.get('password').invalid && (userForm.get('password').dirty || userForm.get('password').touched)"
                            class="invalid-feedback">
                            <div *ngIf="userForm.get('password').errors.required">
                                Password is required
                            </div>
                            <div *ngIf="userForm.get('password').errors.minlength">
                                Password must be at least 8 characters long
                            </div>
                        </div>
                    </div>





                    <div class="mb-3">
                        <input class="form-check-input mb-2" #checkbox type="checkbox"
                            (change)="onChangeIsAdmin($event)">
                        <label class="form-check-label ms-1">Admin</label>
                    </div>
                    <div class="mb-3">
                        <button class="btn btn-primary" type="submit" [disabled]="!userForm.valid">{{"Submit" | translate}}</button>
                    </div>
                </form>
            </div>
            <div class="col-md-6" style="overflow: auto;">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">FirstName</th>
                            <th scope="col">LastName</th>
                            <th scope="col">Username</th>
                            <th scope="col">Email</th>
                            <th scope="col">Manufacturers</th>
                            <th scope="col">Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of (users$ | async); let index = index">
                            <th scope="row">{{index+1}}</th>
                            <td>{{item.firstName}}</td>
                            <td>{{item.lastName}}</td>
                            <td>{{item.username}}</td>
                            <td>{{item.email}}</td>
                            <td><a (click)="openDialog(item.userId)">edit</a></td>
                            <td><a (click)="deleteUser(item.userId)">delete</a></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</section>